import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { w } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import { HorizontalBarChart, targetPlugin } from '@holmescorp/charts';
import css from '../css/progress-chart.m.css';
const defaultScales = {
    xAxes: [
        {
            type: 'linear',
            ticks: { beginAtZero: true, min: 0, max: 100 },
            scaleLabel: { display: false, labelString: '%' }
        }
    ]
};
const ditarootsMissing = `[
	"[settings] ditaroots"
	"[settings] ditaroots"
	"[settings] ditaroots"
	"[settings] ditaroots"
	"[settings] ditaroots"
	"[settings] ditaroots"
]`;
let ProgressChart = class ProgressChart extends I18nThemed {
    get i18nDitabook() {
        const { ditabookBundle } = this.properties;
        return ditabookBundle === undefined
            ? { isPlaceholder: true, format: () => '', messages: {} }
            : this.localizeBundle(ditabookBundle);
    }
    get i18nSettings() {
        const { settingsBundle } = this.properties;
        return settingsBundle === undefined
            ? { isPlaceholder: true, format: () => '', messages: {} }
            : this.localizeBundle(settingsBundle);
    }
    render() {
        const { ditaroots = ditarootsMissing } = this.i18nSettings.messages;
        const roots = JSON.parse(ditaroots);
        const { key, labels = roots, datasets = [], size, ariaLabel = 'progress', chartscales = {}, onClick = () => { }, drawComplete, legend = true, events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'], useMobileVariant = false } = this.properties;
        const scales = Object.assign({}, defaultScales, chartscales);
        const isMobile = window.innerWidth < 992 && useMobileVariant;
        if (isMobile) {
            if (!scales.yAxes || scales.yAxes.length === 0) {
                scales.yAxes = [{ ticks: {}, mirror: false }];
            }
            const yAxis = scales.yAxes[0];
            yAxis.ticks = yAxis.ticks || {};
            yAxis.ticks.mirror = isMobile;
            yAxis.ticks.z = isMobile ? 1 : 0;
            yAxis.ticks.fontColor = '#333';
        }
        const chartprops = {
            pluginCode: [targetPlugin],
            drawComplete,
            ariaLabel,
            size,
            legend: { display: legend, position: 'bottom' },
            options: {
                onClick,
                scales,
                events,
                plugins: [
                    {
                        targetarea: {
                            fillColor: '#90ff9020',
                            strokeColor: '#00ff00',
                            target: 80,
                            label: {
                                enabled: true,
                                text: 'TARGET',
                                strokeColor: '#222222',
                                fontSize: 9
                            }
                        }
                    }
                ]
            },
            data: {
                labels,
                datasets
            }
        };
        return w(HorizontalBarChart, Object.assign({ key }, chartprops));
    }
};
ProgressChart = __decorate([
    theme(css),
    storeInject({
        name: 'lcc-state',
        paths: [['dynls']],
        getProperties: (store) => {
            const { get, path } = store;
            const dynls = get(path('dynls'));
            return {
                ditabookBundle: dynls && dynls.get('ditabook'),
                settingsBundle: dynls && dynls.get('settings')
            };
        }
    })
], ProgressChart);
export { ProgressChart };
